module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-17-2ae25a068da08c90c22a574d24f9a97e.svg";